import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { RestockingState } from './RestockingTypes'

const selectFeature = (state: State) => state.restocking

export const selectProductsList = createSelector(
  selectFeature,
  (state: RestockingState) => state.productsList,
)

export default selectFeature
